import React, { useState, useEffect } from "react";
import CustomTabs from "../Tabs/Tabs";
import { inventoryTabs } from "../../utils/Tabs.config";
import { db } from "../../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { getFilteredList } from "../../utils/Utils";
import {
  InventoryNearExpiryColumns,
  InventoryLowStockColumns,
  InventoryDeadStockColumns,
  InventoryNonMovingStockColumns,
  InventoryZeroStockColumns,
} from "../../data/ColumnHeader";
import EnhancedTable from "../../components/BasicDataGrid/BasicDataGrid";

const columnsMap = {
  zeroStocks: InventoryZeroStockColumns,
  nearExpiryStocks: InventoryNearExpiryColumns,
  lowStocks: InventoryLowStockColumns,
  deadStocks: InventoryDeadStockColumns,
  nonMovingStocks: InventoryNonMovingStockColumns,
};

export default function InventoryUpdates() {
  const [selectedTab, setSelectedTab] = useState(inventoryTabs[0].value);
  const [notifications, setNotifications] = useState([]);
  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    const unsubscribe = listenToNotifications((notifications) => {
      setNotifications(notifications);
    });

    return () => unsubscribe();
  }, []);
  return (
    <>
      <CustomTabs
        tabOptions={inventoryTabs}
        selectedValue={selectedTab}
        onChange={handleTabChange}
      />
      <EnhancedTable
        rows={getFilteredList(notifications, selectedTab)}
        columns={columnsMap[selectedTab] || []}
        title="Inventory Updates"
        isLoading={false}
        isCheckbox={false}
        isDense={false}
        isPagination={true}
        isSearch={true}
        isFilter={false}
      />
    </>
  );
}

export const listenToNotifications = (callback) => {
  const q = query(
    collection(db, "pharmacyNotifications"),
    where("seen", "==", false)
  );
  return onSnapshot(q, (snapshot) => {
    const notifications = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    callback(notifications);
  });
};
